<div class="profile">
  <i class="material-symbols-outlined profile__close" (click)="close()">close</i>
  <div class="profile__data-container">
    <div class="profile__info profile__icon">
      @if (isSuperUser) {
        <i class="material-symbols-outlined"> shield_person </i>
        <p>ADMINISTRATION MODE</p>
      } @else {
        <i class="material-symbols-outlined"> account_circle </i>
      }
    </div>
    <div class="profile__info">
      <div>
        <b>{{ contactName }}</b>
      </div>
      <div>{{ contactEmail }}</div>
    </div>
    <div class="profile__info__details">
      <h1>{{ accountName }}</h1>
      <h1>AC: {{ accountCode }}</h1>
    </div>
  </div>
  <div class="profile__actions-container">
    <div class="profile__action">
      <a (click)="navigateAndClose()">Manage Account</a>
    </div>
    @if (showManageProfile) {
      <div class="profile__action">
        <a (click)="manageProfile()">Manage My Profile</a>
      </div>
    }
    @if (showSwitchUser) {
      <div class="profile__action">
        <a (click)="switchUserAndClose()">Switch Account</a>
      </div>
    }
    <div class="profile__action">
      <a (click)="logoutAndClose()">Log Out</a>
    </div>
  </div>
</div>
